<template>
   <div class='results-wrapper'>
      <div class='ribbon'>
         <svg class='icon' xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
            <path d="M11 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1v-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3h1V7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7h1V2zm1 12h2V2h-2v12zm-3 0V7H7v7h2zm-5 0v-3H2v3h2z"/>
         </svg>
         <span>Results</span>
      </div>
      <slot></slot>
   </div>
</template>

<script>
export default {
   name: 'results-wrapper'
}
</script>

<style lang="scss">
.results-wrapper {
   max-width: 100vw;
   position: relative;

   .ribbon {
      font-family: $primary-font;
      font-size: 1em;
      $offset: 6px;
      position: absolute;
      transform: rotate(90deg);
      transform-origin: top left;
      top: -$offset;
      left: 3.2em;
      padding: 0.4em 1.1em 0.4em 0.8em;
      background: $primary-color;
      color: $light-color;
      border-radius: 0 0.4em 0.4em 0;
      z-index: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      filter: drop-shadow(2px -2px 2px rgba($primary-color, 0.4));

      &::after {
         content: ' ';
         position: absolute;
         width: $offset;
         height: $offset * 0.75;
         top: -($offset * 0.75);
         left: 0;
         background: darken($primary-color, 15%);
         clip-path: polygon(0 100%, 100% 0, 100% 100%);
         z-index: 1001;
      };

      .icon {
         margin-right: 0.6em;
         transform: rotate(-90deg) scale(1.2);
      }
   }
}


.results-wrapper > .el-tabs {
   width: 100%;
   height: 100%;
   background: $secondary-bg;

   * {
      font-family: $primary-font;
   }

   > .el-tabs__header {
      padding: 0.8em 3em 0.5em 5em;
      background: white;
      border-radius: 5px 5px 0 0;
      box-shadow:
         0 1px 2px rgba(0, 0, 0, 0.03),
         0 -2px 3px rgba($primary-color, 0.1);
         
      .el-tabs__active-bar {
         background: $primary-color;
         border-radius: 1.5px;
         height: 3px;
      }
      .el-tabs__item {
         font-family: $primary-font;
         color: lighten($font-color, 15%);
         font-weight: 500;
         font-size: 1em;
         &.is-active {
            color: $primary-color;
            font-weight: 500;
         }
      }
   }
   > .el-tabs__content {
      padding: 0.5em 3em 0.5em 5em;
   }
}

</style>